// export const url = "https://simiinfotech.herokuapp.com"
export const url = "https://admin.simiinfotech.com"